import styled from 'styled-components';
import { size } from '../../layout/helpers';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-wv52s5-0' })`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: ${size(2)};
    font-size: var(--font-size-small-static);
    line-height: 1.3;
`;

export const Icon = styled.div.withConfig({ componentId: 'sc-wv52s5-1' })`
    flex-shrink: 0;

    svg {
        display: block;
        width: auto;
        height: 3lh;
    }
`;

export const Body = styled.div.withConfig({ componentId: 'sc-wv52s5-2' })`
    flex: 1 1 20ch;
    display: flex;
    flex-direction: column;
    gap: ${size(0.25)};

    p {
        margin: 0;
    }
`;

export const Heading = styled.div.withConfig({ componentId: 'sc-wv52s5-3' })`
    font-weight: var(--font-weight-bold);
`;
